
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/shop",
      function () {
        return require("private-next-pages/books/shop/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/shop"])
      });
    }
  